import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AccountLayout from '../components/AccountLayout';
import OrderDetailCard from '@/components/feature/OrderDetailCard';
import { Order, getOrderByNumber } from '@/services/orders';

export default function AccountOrderDetail() {
  const { orderNumber } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState<Order | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!orderNumber) return;
    let alive = true;
    setLoading(true);
    getOrderByNumber(orderNumber)
      .then((data) => {
        if (alive) setOrder(data);
      })
      .catch((err) => {
        if (alive) setError(err instanceof Error ? err.message : '訂單載入失敗。');
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [orderNumber]);

  return (
    <AccountLayout title="訂單詳情">
      <button
        type="button"
        onClick={() => navigate('/account/orders')}
        className="mb-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#5A6B5A] hover:text-[#1B3D2A]"
      >
        <i className="ri-arrow-left-line" />
        返回訂單列表
      </button>
      {loading ? (
        <div className="rounded-2xl border border-[#E8E0D6] bg-[#FAF8F5] py-16 text-center text-sm text-[#9A8A7A]">載入中...</div>
      ) : error || !order ? (
        <div className="rounded-2xl border border-[#f2b8b5] bg-[#fdebea] px-4 py-3 text-sm text-[#c3423f]">{error || '查無此訂單。'}</div>
      ) : (
        <OrderDetailCard order={order} />
      )}
    </AccountLayout>
  );
}
